import React, { useEffect } from "react";
import { Modal, Input, Select, Form, Switch } from "antd";
import { GradePicker } from "../../../components/GradePicker";
import { observer } from "mobx-react";
import { pendingOrgs } from "../../../store/org/pending/PendingOrgsStore";

export const PendingOrgDlg = observer(() => {
  const [form] = Form.useForm();
  const { orgEdit } = pendingOrgs;

  useEffect(() => {
    if (orgEdit.model.id) {
      form.setFieldsValue(orgEdit.model);
    }
  }, [orgEdit.model?.id]);

  const save = () => {
    form.validateFields().then((values) => {
      orgEdit.save(values);
    });
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const onState = (state) => {
    orgEdit.model.state = state;
    form.setFieldsValue({ city: undefined });
  };

  const onDivision = (id) => {
    orgEdit.model.divisionId = id;
    form.setFieldsValue({ communityId: undefined });
  };

  return (
    <Modal
      title="Organization"
      visible={true}
      onOk={() => save()}
      maskClosable={false}
      confirmLoading={orgEdit.saving}
      onCancel={() => orgEdit.close()}
      width={760}
    >
      <Form form={form} {...layout} initialValues={{ ...orgEdit.model }}>
        <Form.Item label="Full Name" name="name" rules={[{ required: true, message: "Please input full name" }]}>
          <Input placeholder="Enter full name" />
        </Form.Item>
        <Form.Item label="Division" name="divisionId" rules={[{ required: true, message: "Please select division" }]}>
          <Select onChange={onDivision}>
            {orgEdit.divisions.map((x) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Community"
          name="communityId"
          rules={[{ required: true, message: "Please select community" }]}
        >
          <Select>
            {orgEdit.communities.map((x) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="State" name="state" rules={[{ required: true, message: "Please select state" }]}>
          <Select showSearch placeholder="Enter state" optionFilterProp="title" onChange={onState}>
            {orgEdit.states.map((x) => (
              <Select.Option title={`${x.value} (${x.key})`} value={x.key} key={x.key}>
                {x.value} ({x.key})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="City" name="city" rules={[{ required: true, message: "Please select city" }]}>
          <Select showSearch placeholder="Enter city">
            {orgEdit.cityList.map((x) => (
              <Select.Option value={x} key={x}>
                {x}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Street Address" name="street" rules={[{ required: true, message: "Please input address" }]}>
          <Input placeholder="Enter street" />
        </Form.Item>
        <Form.Item label="Zip Code" name="zipCode" rules={[{ required: true, message: "Please input zip code" }]}>
          <Input placeholder="Enter zip code" />
        </Form.Item>
        <Form.Item label="Notes" name="description">
          <Input placeholder="Enter notes" />
        </Form.Item>

        <Form.Item label="Can Fundraising" name="canFund" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="Is School" name="isSchool" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="Grade Range" name="grades">
          <GradePicker />
        </Form.Item>
      </Form>
    </Modal>
  );
});
